import React, { useMemo } from 'react';
import AdminMarketerConsultantPage from './AdminMarketerConsultantPage';

function normalizeCompanies(companyCodes) {
  return Array.isArray(companyCodes)
    ? companyCodes
        .map((code) => String(code || '').trim().toUpperCase())
        .filter(Boolean)
        .map((code) => ({ code, name: code }))
    : [];
}

export default function IntegratedMarketerConsultant({ menuId, companyCodes, pageTitle }) {
  const availableCompanies = useMemo(() => normalizeCompanies(companyCodes), [companyCodes]);

  return (
    <AdminMarketerConsultantPage
      availableCompanies={availableCompanies}
      integratedMenuId={menuId}
      pageTitle={pageTitle || '마케터 1:1 관리'}
    />
  );
}
